import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth0Service } from '../services/auth0.service';

// /login and /login-blink must keep their own path until the Auth0 redirect
// leaves: Auth0Service picks the backdoor organization from
// window.location.pathname === '/login-blink'. Without a route they fall to the
// '**' redirect, the path becomes /links and the primary SSO organization is used.
export const loginRouteGuard: CanActivateFn = async () => {
  const auth0Service = inject(Auth0Service);
  const router = inject(Router);

  if (auth0Service.isAuthenticated()) {
    return router.createUrlTree(['/links']);
  }

  await auth0Service.loginWithRedirect();

  return false;
};
